/*!
 * @license
 * Copyright 2016 Alfresco Software, Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'adf-viewer-unknown-format',
  templateUrl: 'unknown-format.component.html',
  styleUrls: ['unknown-format.component.scss']
})
export class UnknownFormatComponent {
  @Output()
  public exit = new EventEmitter();

  @Input()
  showToolbar = true;

  @Input() elementId: string;
  @Input() parentId: string;
  @Input() fileName: string;
  @Input()
  urlFile: string;

  @Input() creator: string;
  @Input() size: number;
  @Input() creationDate: string;
  @Input() modifier: string;
  @Input() modificationDate: string;
  @Input() type: string;
  @Input()
  nameFile: string;
  @Input() originalMimeType: string;
  @Input() mimeType: string;
  @Input()
  thumbnailsTemplate: TemplateRef<any> = null;
  @Input()
  allowThumbnails = false;
}
